export default __webpack_public_path__ + "static/media/NoirPro-Light.d145a875.woff2";